import { Transaction } from "../types";

export function isRefunded(refundStatus?: string): boolean {
  return refundStatus !== undefined && refundStatus !== "Not Refunded";
}

export function isNegative(transaction: Transaction): boolean {
  return transaction.credit_type === "refund_redemption";
}
